import { render, staticRenderFns } from "./PlanejamentoAcaoFormAnexoArquivo.vue?vue&type=template&id=49b2076a&scoped=true&"
import script from "./PlanejamentoAcaoFormAnexoArquivo.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoAcaoFormAnexoArquivo.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoAcaoFormAnexoArquivo.vue?vue&type=style&index=0&id=49b2076a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b2076a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardTitle,VIcon,VRow,VTextField,VTooltip})
